import React from "react";
import HomePage from "./pages/HomePage";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RecipeDetailsPage from "./pages/RecipeDetailsPage";
import "../styles/styles.css";

const App: React.FC = (props: any) => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/recipe/:uuid/details" element={<RecipeDetailsPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
